var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFirst(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_15401",
    "data-name": "Group 15401",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72.1,
    height: 102.446,
    viewBox: "0 0 72.1 102.446",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffef6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fefea4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ffe645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#fff87f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd62a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M63.662,252.781v49.1l23.32-9.233,22.6,9.233v-49.1Z",
    transform: "translate(-63.662 -252.781)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M79.991,299.893l-2,.791v-47.9h2Z",
    transform: "translate(-77.992 -252.781)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.005,
    y1: 1.213,
    x2: 0.011,
    y2: 1.213,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4c900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#ffe354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#fffc94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff100"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M258.262,299.893l2,.791v-47.9h-2Z",
    transform: "translate(-258.262 -252.781)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -1.073,
    y1: 1.213,
    x2: -1.067,
    y2: 1.213,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M36.406,2.133,34.148.451,32.118,2.4l-2.45-1.387L27.9,3.2l-2.6-1.068L23.812,4.526,21.094,3.8,19.929,6.358l-2.79-.384L16.3,8.662l-2.815-.032L12.994,11.4l-2.8.319-.146,2.811L7.317,15.2l.207,2.807-2.63,1,.557,2.758L2.97,23.1l.9,2.665L1.575,27.392l1.23,2.532L.733,31.83l1.538,2.357L.452,36.336l1.819,2.148L.733,40.841l2.072,1.906L1.575,45.28l2.294,1.627-.9,2.667L5.452,50.9l-.557,2.76,2.63,1-.207,2.807,2.735.667.146,2.811,2.8.321.494,2.771,2.815-.032.836,2.689,2.788-.382,1.167,2.56,2.718-.73,1.481,2.4,2.6-1.068,1.771,2.188,2.45-1.389,2.03,1.948,2.258-1.682,2.258,1.682,2.03-1.948,2.45,1.389,1.771-2.188,2.6,1.068L49,68.143l2.72.732,1.165-2.562,2.79.382.836-2.689,2.815.032.494-2.771,2.8-.321.146-2.811,2.735-.667-.207-2.807,2.63-1-.557-2.76,2.482-1.325-.9-2.665,2.294-1.629-1.23-2.532,2.072-1.906-1.538-2.357,1.819-2.148-1.819-2.148L72.08,31.83l-2.072-1.906,1.23-2.532-2.294-1.629.9-2.665L67.361,21.77l.557-2.758-2.63-1L65.5,15.2l-2.735-.665-.146-2.813-2.8-.319-.494-2.771-2.815.03-.836-2.687-2.788.382L51.72,3.8,49,4.526,47.52,2.133,44.915,3.2,43.145,1.012,40.695,2.4,38.662.451Z",
    transform: "translate(-0.452 -0.451)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_355",
    "data-name": "Rectangle 355",
    width: 72.1,
    height: 102.446,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M52.8,80.409A27.947,27.947,0,1,1,80.749,52.463,27.98,27.98,0,0,1,52.8,80.409ZM21.232,52.463A31.569,31.569,0,1,0,52.8,20.892,31.569,31.569,0,0,0,21.232,52.463",
    transform: "translate(-21.232 -20.892)",
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_707",
    "data-name": "Group 707",
    transform: "translate(13.435 53.346)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_706",
    "data-name": "Group 706",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_351",
    "data-name": "Rectangle 351",
    width: 45.922,
    height: 49.1,
    transform: "translate(0 0)",
    fill: "#d8d8d8"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_709",
    "data-name": "Group 709",
    transform: "translate(16.459 53.346)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_708",
    "data-name": "Group 708",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_352",
    "data-name": "Rectangle 352",
    width: 35.286,
    height: 35.286,
    transform: "translate(-23.952 23.952) rotate(-45)",
    fill: "url(#linear-gradient-3)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_711",
    "data-name": "Group 711",
    transform: "translate(54.503 53.346)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_710",
    "data-name": "Group 710",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_353",
    "data-name": "Rectangle 353",
    width: 35.283,
    height: 35.286,
    transform: "translate(-23.952 23.95) rotate(-44.998)",
    fill: "url(#linear-gradient-4)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_713",
    "data-name": "Group 713",
    transform: "translate(0.095 0.095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_712",
    "data-name": "Group 712",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_354",
    "data-name": "Rectangle 354",
    width: 95.502,
    height: 95.433,
    transform: "matrix(0.906, -0.423, 0.423, 0.906, -27.488, 12.818)",
    fill: "url(#linear-gradient)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_715",
    "data-name": "Group 715"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_714",
    "data-name": "Group 714",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M72.361,36.336l-1.819,2.148,1.538,2.357-2.072,1.906,1.23,2.532-2.294,1.629.9,2.665L67.362,50.9l.557,2.76-2.63,1,.207,2.807-2.735.667-.146,2.811-2.8.321-.494,2.771-2.815-.032L55.674,66.7l-2.79-.382-1.165,2.562L49,68.143l-1.479,2.4-2.6-1.068-1.771,2.188-2.45-1.389-2.03,1.948-2.258-1.682-2.258,1.682-2.03-1.948-2.45,1.389L27.9,69.471l-2.6,1.068-1.481-2.4-2.718.73-1.167-2.56-2.788.382L16.3,64.007l-2.815.032-.494-2.771-2.8-.321-.146-2.811-2.735-.667.207-2.807-2.63-1,.557-2.76L2.97,49.574l.9-2.667L1.575,45.28l1.23-2.532L.733,40.841l1.538-2.357L.452,36.336l1.819-2.148L.733,31.83l2.072-1.906-1.23-2.532,2.294-1.629L2.97,23.1,5.452,21.77l-.557-2.758,2.63-1L7.317,15.2l2.735-.667.146-2.811,2.8-.319.494-2.773,2.815.032.836-2.689,2.79.384L21.094,3.8l2.718.73,1.481-2.393L27.9,3.2l1.771-2.188L32.118,2.4,34.148.451l2.258,1.682L38.663.451,40.695,2.4l2.45-1.387L44.916,3.2l2.6-1.068L49,4.526l2.718-.73,1.167,2.562,2.788-.382.836,2.687,2.815-.03.494,2.771,2.8.319.146,2.813L65.5,15.2l-.207,2.807,2.63,1-.557,2.758L69.843,23.1l-.9,2.665,2.294,1.629-1.23,2.532L72.08,31.83l-1.538,2.357Z",
    transform: "translate(-0.357 -0.356)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.69
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_717",
    "data-name": "Group 717",
    transform: "translate(4.481 4.409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_716",
    "data-name": "Group 716",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_356",
    "data-name": "Rectangle 356",
    width: 89.292,
    height: 89.292,
    transform: "translate(-31.57 31.57) rotate(-45)",
    fill: "url(#linear-gradient)"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_719",
    "data-name": "Group 719"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_718",
    "data-name": "Group 718",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M52.8,20.892A31.57,31.57,0,1,0,84.37,52.463,31.57,31.57,0,0,0,52.8,20.892Zm0,59.517A27.947,27.947,0,1,1,80.749,52.463,27.98,27.98,0,0,1,52.8,80.409Z",
    transform: "translate(-16.751 -16.483)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M94.757,66.869A27.537,27.537,0,1,1,67.221,39.331,27.537,27.537,0,0,1,94.757,66.869Z",
    transform: "translate(-31.308 -31.031)",
    fill: "none",
    stroke: "#251e1c",
    strokeWidth: 2.02
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M92.6,63.706A28.564,28.564,0,1,1,64.036,35.142,28.563,28.563,0,0,1,92.6,63.706Z",
    transform: "translate(-27.986 -27.726)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.86
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirst);
export default __webpack_public_path__ + "static/media/first.a0aed1656172b8ded32275d21eaee0a9.svg";
export { ForwardRef as ReactComponent };